import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { BadgeCheck, ArrowRight, User } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { API } from "../api";
import { Reveal } from "./motion";

const photoUrl = (path) => `${API}/public/files/${path}`;

export const VerifiedTeaser = () => {
  const { t } = useLang();
  const v = t.verifiedTeaser;
  const [pros, setPros] = useState([]);

  useEffect(() => {
    axios.get(`${API}/professionals/public`).then(({ data }) => setPros(data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section id="verified" className="relative py-20 md:py-28 scroll-mt-24" data-testid="verified-teaser">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="rounded-[2rem] border border-line bg-cream/60 p-8 md:p-14">
          <div className="max-w-2xl">
            <Reveal><span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-forest"><BadgeCheck size={15} /> HomeHealthy</span></Reveal>
            <Reveal delay={0.05}><h2 className="mt-4 font-heading text-3xl md:text-4xl font-light tracking-tight text-ink leading-[1.1]">{v.title}</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-4 text-lg text-ink-soft leading-relaxed">{v.subtitle}</p></Reveal>
          </div>

          {pros.length > 0 && (
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {pros.map((pro) => (
                <Link key={pro.id} to={`/profesional/${pro.id}`} className="group flex items-center gap-4 rounded-2xl border border-line bg-white p-4 hover:shadow-[0_16px_40px_rgb(3,33,42,0.10)] transition-all duration-500 hover:-translate-y-1" data-testid={`teaser-pro-${pro.id}`}>
                  <div className="w-16 h-16 rounded-2xl overflow-hidden bg-cream-deep shrink-0">
                    {pro.photo ? <img src={photoUrl(pro.photo)} alt={pro.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-ink-faint"><User size={24} /></div>}
                  </div>
                  <div className="min-w-0">
                    <div className="inline-flex items-center gap-1 text-xs font-semibold text-forest"><BadgeCheck size={13} /> {t.publicPro.verified}</div>
                    <div className="font-heading text-lg font-medium text-ink truncate">{pro.name} {pro.last_name}</div>
                    <div className="text-sm text-ink-faint truncate">{pro.categories.map((c) => t.categories[c]?.label || c).join(" · ")}</div>
                  </div>
                </Link>
              ))}
            </div>
          )}

          <Reveal delay={0.1} className="mt-10">
            <Link to="/profesionales" className="group inline-flex items-center gap-2 rounded-full border border-forest text-forest font-semibold px-7 py-3.5 hover:bg-forest hover:text-white transition-all duration-300 hover:-translate-y-1" data-testid="verified-cta">
              {v.cta} <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
